export default __webpack_public_path__ + "images/ATV.fc4b848.png";